import {Linking} from 'react-native';
import {IS_WEB} from '../utils/platform';

/**
 * Subscribe to auth callback URLs (password recovery, future magic links).
 * No-op on web (Supabase parses the URL in the browser).
 */
export function subscribeAuthDeepLink(onUrl) {
  if (IS_WEB) {
    return () => {};
  }
  const subscription = Linking.addEventListener('url', ({url}) => {
    onUrl(url);
  });
  Linking.getInitialURL().then(url => {
    if (url) {
      onUrl(url);
    }
  });
  return () => subscription.remove();
}
